import { render, staticRenderFns } from "./BpTabs.vue?vue&type=template&id=307ecda6&"
import script from "./BpTabs.vue?vue&type=script&lang=js&"
export * from "./BpTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307ecda6')) {
      api.createRecord('307ecda6', component.options)
    } else {
      api.reload('307ecda6', component.options)
    }
    module.hot.accept("./BpTabs.vue?vue&type=template&id=307ecda6&", function () {
      api.rerender('307ecda6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/styles/molecules/tabs/BpTabs.vue"
export default component.exports